import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("button5", component(opts));
  editor.BlockManager.add("button5", block(opts));
};